import { render, staticRenderFns } from "./serviceProducts.vue?vue&type=template&id=22d9948f&scoped=true"
import script from "./serviceProducts.vue?vue&type=script&lang=js"
export * from "./serviceProducts.vue?vue&type=script&lang=js"
import style0 from "./serviceProducts.vue?vue&type=style&index=0&id=22d9948f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9948f",
  null
  
)

export default component.exports